export default __webpack_public_path__ + "static/media/ic_avalanche_16.674a499b.svg";